<template>
    <div id="moreproducts">
        <h3>More Products from Us</h3>
        <div class="row">
            <div class="col-sm-4">
                <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://assets.sennheiser.com/img/20956/product_detail_x1_mobile_MOMTW_1312x1312px.jpg" alt="Avatar">
                <h3>MOMENTUM True Wireless</h3>
                <p>Sennheiser's exquisite MOMENTUM True Wireless ear buds set new standard for audio quality.</p>
                <span>US$299.95</span>
            </div>
            <div class="col-sm-4">
                <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://assets.sennheiser.com/img/19472/product_detail_x1_mobile_Sennheiser-Product-IE-400-PRO-Smoky-Spread-Main-Image.jpg" alt="Avatar">
                <h3>IE 400 Pro</h3>
                <p>Noticeable punch, clear high frequencies and transparent mid-range reproduction.</p>
                <span><strike>US$349.95</strike> US$199.95</span>
            </div>
            <div class="col-sm-4">
                <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://www.audio-technica.com/cms/resource_library/product_images/9808b5d44ab899ea/med/ath_m50x_3_sq.jpg" alt="Avatar">
                <h3>ATH-M50x</h3>
                <p>ATH-M50x professional monitor headphones feature the same coveted sonic signature, with the added feature of detachable cables.</p>
                <span>US$149.00</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MoreProducts"
    }
</script>

<style lang="scss">
    #moreproducts {

    }
</style>
